import type { PlanCost, PlanCostAmounts } from '../types/financials.types';

export interface CostRow extends PlanCostAmounts {
    id: string;
    label: string;
    isTotal: boolean;
}

export const toRows = (planCost: PlanCost): CostRow[] => [
    ...planCost.lines.map((line, index) => ({ ...line, id: `${line.key}-${index}`, isTotal: false })),
    { ...planCost.total, id: 'total', label: 'Total plan cost', isTotal: true },
];
